export default __webpack_public_path__ + "static/media/white_AA.3362e0d6.svg";